import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "./http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../models/base-response";
import {Notificacao} from "../models/notificacao";
import {VistoNotificacao} from "../models/visto-notificacao";
import {environment} from "@env/environment";

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`NotificacaoService`);
  }

  baseUrl = environment.apiUrl;

  buscarPorUsuario(): Observable<BaseResponse<Notificacao[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<Notificacao[]>>(`${this.baseUrl}/Notificacao/BuscarPorUsuario`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorUsuario')));
  }

  visto(request: VistoNotificacao): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Notificacao/VistoPorUsuario`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  limparNotificacoes(): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Notificacao/LimparNotificacoesPorUsuario`, {})
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('limparNotificacoes')));
  }
}
